import React, { useContext } from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import { useStaticQuery, graphql, Link } from 'gatsby'
import StoreContext from '~/context/StoreContext'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import '../../utils/fontawesome'
// import { Img } from '~/utils/styles'

const ProductGrid = () => {
  const { store: { checkout } } = useContext(StoreContext)
  const { allShopifyCollection } = useStaticQuery(
    graphql`
      query {
        allShopifyCollection(
          filter: {title: {}}
        ) {
          edges {
            node {
              id
              title
              handle
              image {
                id
                localFile {
                  childImageSharp {
                    fluid {
                      base64
                      tracedSVG
                      aspectRatio
                      src
                      srcSet
                      srcWebp
                      srcSetWebp
                      sizes
                      originalImg
                      originalName
                      presentationWidth
                      presentationHeight
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )

  const getPrice = price => Intl.NumberFormat(undefined, {
    currency: checkout.currencyCode ? checkout.currencyCode : 'EUR',
    minimumFractionDigits: 2,
    style: 'currency'
  }).format(parseFloat(price ? price : 0))

  return (
    <>

      <section className='section' id='kategorien' style={{ background: '#fff', position: 'relative' }}>
        <Banner>
          <label className='has-text-primary'>Kategorien</label>

        </Banner>
        <div className='columns is-multiline'>

          {allShopifyCollection.edges
            ? allShopifyCollection.edges.map(({ node: { id, handle, title, image } }) => (
              <div className='column is-3' key={id}>
                <Category>
                  <Link to={`/category/${handle}/`}>
                    <Zoom>
                      <Image
                        fluid={image.localFile.childImageSharp.fluid}
                        alt={handle}
                      />
                    </Zoom>

                  <ProductInfo>
                    <Title className='has-text-primary has-text-centered'>{title}</Title>

                  </ProductInfo>
                  <span className='categoryExplore'>
                    <Link to={`/category/${handle}/`} className='button is-primary is-marginless'>
                      erkunden
                    </Link>
                  </span>
                  </Link>
                </Category>
              </div>
            ))
            : <p>Keine Kategorien gefunden! Versuche die Seite neu zu laden!</p>}
        </div>
      </section>
    </>
  )
}

export default ProductGrid

const Banner = styled.div`
  position: sticky;
  top: 77px;
  left: 0px;
  margin-bottom: 2rem;
  z-index: 1;
  width: 100%;
  background: #161c27;
  // background: -moz-linear-gradient(120deg, rgba(252,148,57,1) 0%, rgba(116,56,94,1) 100%);
  // background: -webkit-linear-gradient(120deg, rgba(213,97,78,1 ) 0%,rgba(116,56,94,1) 100%);
  // background: linear-gradient(120deg, rgba(240,225,2,1) 0%,rgba(213,97,78,1) 100%);
  padding: 10px;
  font-size: 1.5rem;
  // color: #fff;
  text-align: center;
  font-weight: 900;
  text-transform: uppercase;
`

const Category = styled.div`
  position: relative;
  border-radius: 3px;
  box-shadow: 0 0 10px rgba(0,0,0,.1);
  .categoryExplore{
    display: none;
    position: absolute;
    text-align: center;
    bottom: 20px;
    right: 0;
    left: 0;
    margin-left: auto;
    margin-right: auto;
    border: none;
    font-size: 1.4rem;
  }
  &:hover{
    .categoryExplore{
      display: inline-block;
    }
  }
`

const ProductInfo = styled.div`

`

const Title = styled.h1`
  position: absolute;
  min-width: 100%;
  top: 50%;
  background: rgba(0,0,0,0.7);
  padding: 10px;
  font-family: Montserrat;
  text-transform: uppercase;
  font-size: 1.6rem;
  line-height: 1.2;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  hyphens: auto;
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
`

const Zoom = styled.div`
  overflow: hidden;
  height: 300px;
`

const Image = styled(Img)`
  max-width: 100%;
  height: 300px;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.15);
  transition: transform .5s ease;
  &:hover{
    transform: scale(1.1);
  }
`
